import axiosInstance from "../axiosInstance";

const BASE_URL = "/system/app_versions";

/** @param {'pwa_fe'|'pwa_be'|'mobile'|'pwa'} [platform='pwa_fe'] */
export const getLatestVersion = async (platform = "pwa_fe") => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/latest`, {
      params: { platform },
    });
    return res.data;
  } catch (error) {
    console.error("❌ Lỗi khi lấy phiên bản mới nhất:", error);
    throw error.response?.data || { message: "Không thể lấy phiên bản mới nhất" };
  }
};

/** @param {'pwa_fe'|'pwa_be'|'mobile'|null} [platform] */
export const getAllVersions = async (platform) => {
  try {
    const res = await axiosInstance.get(BASE_URL, {
      params: platform ? { platform } : undefined,
    });
    return res.data;
  } catch (error) {
    console.error("❌ Lỗi khi lấy danh sách phiên bản:", error);
    throw error.response?.data || { message: "Không thể lấy danh sách phiên bản" };
  }
};

export const createVersion = async (payload) => {
  try {
    const res = await axiosInstance.post(BASE_URL, payload);
    return res.data;
  } catch (error) {
    console.error("❌ Lỗi khi tạo phiên bản mới:", error);
    throw error.response?.data || { message: "Không thể tạo phiên bản mới" };
  }
};

export const updateVersion = async (id, payload) => {
  try {
    const res = await axiosInstance.put(`${BASE_URL}/${id}`, payload);
    return res.data;
  } catch (error) {
    console.error("❌ Lỗi khi cập nhật phiên bản:", error);
    throw error.response?.data || { message: "Không thể cập nhật phiên bản" };
  }
};

export const deleteVersion = async (id) => {
  try {
    const res = await axiosInstance.delete(`${BASE_URL}/${id}`);
    return res.data;
  } catch (error) {
    console.error("❌ Lỗi khi xóa phiên bản:", error);
    throw error.response?.data || { message: "Không thể xóa phiên bản" };
  }
};
